import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { TypeActionOutskirtsInfo } from "../actionOutskirtsInfo";
import { checkOutskirtBuildingHasEnoughResources } from "../checks/checkOutskirtBuildingHasEnoughResources";
import { pathOutskirtBuildingUpgrade } from "../paths/pathOutskirtBuildingUpgrade";
import { pathOutskirtBuildingUpgradeNotEnoughResources } from "../paths/pathOutskirtBuildingUpgradeNotEnoughResources";
export var epicOutskirtBuildingUpgrade = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionOutskirtsInfo.Upgrade), guard(state$, deps, pathOutskirtBuildingUpgrade)([
        checkOutskirtBuildingHasEnoughResources(pathOutskirtBuildingUpgradeNotEnoughResources),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicOutskirtBuildingUpgrade.ts
// module id = 1920
// module chunks = 3